<template>
  <v-dialog v-model="open" persistent max-width="400px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="light-green darken-1" dark v-bind="attrs" v-on="on">
        Bulk Upload
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Bulk File Upload</span>
      </v-card-title>
      <v-card-text>
        <v-file-input
          v-model="file"
          label="Select CSV files"
          show-size
          counter
          prepend-icon="mdi-paperclip"
        >
          <template v-slot:selection="{ text }">
            <v-chip small label color="primary">{{ text }}</v-chip>
          </template>
        </v-file-input>
        <v-row no-gutters class="justify-center">
          <v-col cols="7">
            <v-text-field
              label="Delimiter"
              :messages="['*Symbol which separet each item']"
              hide-details="auto"
              v-model="delimiter"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters class="justify-center">
          <v-col cols="7">
            <v-select
              v-model="lt"
              :items="types"
              item-value="id"
              item-text="title"
              label="Lead Type"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="open = false">Close</v-btn>
        <v-btn color="blue darken-1" class="white--text" @click="sendFile"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "BulkFileUpload",
  data() {
    return {
      lt: "life",
      file: [],
      open: false,
      delimiter: "",
      types: [
        { id: "life", title: "Life" },
        { id: "health", title: "Health" },
      ],
    };
  },
  methods: {
    ...mapActions({
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
    }),

    sendFile() {
      this.open = false;
      let formData = new FormData();

      formData.append("file", this.file);

      formData.append("delimiter", this.delimiter);

      formData.append("lt", this.lt);

      this.$axios
        .post("/lead/upload/bulk-csv", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
        })
        .catch((e) => {
          console.error(e);
          this.showHandlerSnackbar({
            color: e.response.data.status,
            text: e.response.data.message,
            show: true,
          });
        });
    },
  },
};
</script>

<style>
</style>